
<div>
    <div class="content_box" v-if="!isLoading">
        <div class="page-title-cont">
            <div class="page-title-txt">
                <h1>الرهون</h1>
            </div>

        </div>

        <ul class="nav nav-tabs micro-tabs mw-100" v-if="institute">
            <li class="nav-item" v-for="(item, index) in filterInstituteTabList">
                <a href="javascript:" class="nav-link" :class="{active:item.isSelected}"
                   @click="changeFilterTab(index)">{{item.label}} </a>
            </li>
        </ul>
        <ul class="nav nav-tabs micro-tabs mw-100" v-else>
            <li class="nav-item" v-for="(item, index) in filterTabList">
                <a href="javascript:" class="nav-link" :class="{active:item.isSelected}"
                   @click="changeFilterTab(index)">{{item.label}} </a>
            </li>
        </ul>
        <div class="col-md-12" v-if="viewAlertDiv">
            <div class="List-alert" >
            <div class="issue__success w-100">
            <div class="issue__successCircle"></div>
            <div class="issue__successContent">
                <h5 class="issue__successTitle mt-2"> 
                    {{alertText}}
                </h5>
            </div>
            </div>
            </div>
        </div>
        <filter-component :filter-fields="filterFields" @onchange="onFilterChanged" :closeIt="fireToClose" v-show="records.length > 0 || searchActivated" :isInstitute="institute"></filter-component>
        
        <div class="listing-cont">
            <data-table :columns="requestColumns" :rows="records" :config="dataTableConfig" v-if="records.length > 0  && !institute && selectedTab !== 0" >
                <template slot="MorgtgeeName" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.MorgtgeeName}}
                    </div>
                </template>
                <template slot="MortgageIssueDate" slot-scope="props">
                    <div v-if="props.row.MortgageIssueDate == '0001-01-01T00:00:00'" style="font-size:20px; color:#01353d;">
                        {{ props.row.RequestCreationDate.toString().split('T')[0] }}
                        <!--<small>
                    </small>-->
                    </div>
                    <div v-else style="font-size:20px; color:#01353d;">
                        {{ props.row.MortgageIssueDate !== null ? props.row.MortgageIssueDate.toString().split('T')[0] : props.row.RequestCreationDate }}
                        <!--<small>
                    </small>-->
                    </div>
                </template>

                <template slot="Id" slot-scope="props">

                    <div class="inquery-item-id">
                        <router-link :to="'/View/'+props.row.IndustrialMortgageRequestId+props.row.MortgageType">
                            <span class="inqiery-link-info">
                                <span class="inquery-item-info-t">{{ props.column.label }}</span>
                                <span class="inquery-item-info-v">
                                    {{ selectedTab == 0 ? props.row.DocumentNumber : props.row.ApplicationNumber }}
                                </span>
                            </span>
                            <span class="servicesButton__seeMore"></span>
                        </router-link>
                    </div>
                </template>
                
               
                <!-- <template slot="lstPersonInfo" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.lstPersonInfo.find(i => i.IDNumber === userOpeningSessionId).ApprovalStatusText}}
                    </div>
                </template> -->
                <template slot="MortgageStatusText" slot-scope="props">

                    <span  style="font-size:20px; color:#01353d;">
                        <!-- <i :class="'dashboardActionHeading__status status--'+getStatusColor(props.row.MortgageStatus)+' status--bullet status--bulletLeft'"> </i> -->
                        {{ props.row.MortgageStatusText }}
                    </span>
                </template>

                <template slot="empty-results">
                    <div class="List__empty">
                        <img :src='require("./../../../public/img/folder.svg")' alt="No Data">
                        <h4 class="List__title"v-if="searchActivated">لا توجد نتائج مطابقة لمدخلات البحث</h4>
                        <h4 class="List__title" v-else>لا توجد طلبات خاصة بك</h4>
                    </div>
                </template>
            </data-table>
            <data-table :columns="columns" :rows="records" :config="dataTableConfig" v-if="records.length > 0  && !institute && selectedTab == 0" >
                <template slot="MortgageStatusText" slot-scope="props">

                    <span  style="font-size:20px; color:#01353d;">
                        <!-- <i :class="'dashboardActionHeading__status status--'+getStatusColor(props.row.MortgageStatus)+' status--bullet status--bulletLeft'"> </i> -->
                        {{ props.row.MortgageStatusText }}
                    </span>
                </template>
                <template slot="MorgtgeeName" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.MorgtgeeName}}
                    </div>
                </template>
                <template slot="MortgageIssueDate" slot-scope="props">
                    <div v-if="props.row.MortgageIssueDate == '0001-01-01T00:00:00'" style="font-size:20px; color:#01353d;">
                        {{ props.row.RequestCreationDate.toString().split('T')[0] }}
                        <!--<small>
                    </small>-->
                    </div>
                    <div v-else style="font-size:20px; color:#01353d;">
                        {{ props.row.MortgageIssueDate !== null ? props.row.MortgageIssueDate.toString().split('T')[0] : props.row.RequestCreationDate }}
                        <!--<small>
                    </small>-->
                    </div>
                </template>

                <template slot="Id" slot-scope="props">

                    <div class="inquery-item-id">
                        <router-link :to="'/View/'+props.row.IndustrialMortgageRequestId+props.row.MortgageType">
                            <span class="inqiery-link-info">
                                <span class="inquery-item-info-t">{{ props.column.label }}</span>
                                <span class="inquery-item-info-v">
                                    {{ selectedTab == 0 ? props.row.DocumentNumber : props.row.ApplicationNumber }}
                                </span>
                            </span>
                            <span class="servicesButton__seeMore"></span>
                        </router-link>
                    </div>
                </template>
                <!-- <template slot="lstPersonInfo[0]" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.lstPersonInfo[0].FirstName}} {{props.row.lstPersonInfo[0].FatherName}} {{props.row.lstPersonInfo[0].FamilyName}}
                    </div>
                </template> -->
                

                <template slot="empty-results">
                    <div class="List__empty">
                        <img :src='require("./../../../public/img/folder.svg")' alt="No Data">
                        <h4 class="List__title"v-if="searchActivated">لا توجد نتائج مطابقة لمدخلات البحث</h4>
                        <h4 class="List__title" v-else>لا توجد طلبات خاصة بك</h4>
                    </div>
                </template>
            </data-table>
            <data-table :columns="instituteColumns" :rows="records" :config="dataTableConfig" v-if="records.length > 0 && institute">
                <template slot="MortgageStatusText" slot-scope="props">

                    <span style="font-size:20px; color:#01353d;">
                        <!-- <i :class="'dashboardActionHeading__status status--'+getStatusColor(props.row.MortgageStatus)+' status--bullet status--bulletLeft'"> </i> -->
                        {{ props.row.MortgageStatusText }}
                    </span>
                </template>
                <template slot="MortgageIssueDate" slot-scope="props">
                    <div v-if="props.row.MortgageIssueDate == '0001-01-01T00:00:00'" style="font-size:20px; color:#01353d;">
                        {{ props.row.RequestCreationDate.toString().split('T')[0] }}
                        <!--<small>
                    </small>-->
                    </div>
                    <div v-else style="font-size:20px; color:#01353d;">
                        {{ props.row.MortgageIssueDate !== null ? props.row.MortgageIssueDate.toString().split('T')[0] : props.row.RequestCreationDate }}
                        <!--<small>
                    </small>-->
                    </div>
                </template>

                <template slot="Id" slot-scope="props">

                    <div class="inquery-item-id">
                        <router-link :to="'/View/'+props.row.IndustrialMortgageRequestId+props.row.MortgageType">
                            <span class="inqiery-link-info">
                                <span class="inquery-item-info-t">{{ props.column.label }}</span>
                                <span class="inquery-item-info-v">
                                    {{ selectedTab == 0 ? props.row.DocumentNumber : props.row.ApplicationNumber }}
                                </span>
                            </span>
                            <span class="servicesButton__seeMore"></span>
                        </router-link>
                    </div>
                </template>
                <template slot="lstPersonInfo" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.lstPersonInfo.length > 1 ? `${props.row.lstPersonInfo[0].FirstName} ${props.row.lstPersonInfo[0].FatherName} ${props.row.lstPersonInfo[0].FamilyName}, ${props.row.lstPersonInfo[1].FirstName} ${props.row.lstPersonInfo[1].FatherName} ${props.row.lstPersonInfo[1].FamilyName}, ......` : `${props.row.lstPersonInfo[0].FirstName} ${props.row.lstPersonInfo[0].FatherName} ${props.row.lstPersonInfo[0].FamilyName}`}}
                        <!-- {{props.row.lstPersonInfo[0].FirstName}} {{props.row.lstPersonInfo[0].FatherName}} {{props.row.lstPersonInfo[0].FamilyName}} -->
                    </div>
                </template>
                <template slot="MorgtgeeName" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;">
                        {{props.row.MorgtgeeName}} 
                    </div>
                </template>
                <template slot="IsInstitutionIdMortgagee" slot-scope="props">
                    <div style="font-size:20px; color:#01353d;" >
                        {{props.row.IsInstitutionIdMortgagee ? 'مرتهن' : 'راهن'}}
                    </div>
                   
                    
                </template>
                <template slot="empty-results">
                    <div class="List__empty">
                        <img :src='require("./../../../public/img/folder.svg")' alt="No Data">
                        <h4 class="List__title"v-if="searchActivated">لا توجد نتائج مطابقة لمدخلات البحث</h4>
                        <h4 class="List__title" v-else>لا توجد طلبات خاصة بك</h4>
                    </div>
                </template>
            </data-table>
        </div>
        <div v-if="records.length < 1">
            <div class="row">
                <div class="col-md-12">
                    <div class="List__empty">
                        <img :src='require("./../../../public/img/folder.svg")' alt="No Data">
                        <h4 class="List__title"v-if="searchActivated">لا توجد نتائج مطابقة لمدخلات البحث</h4>
                        <h4 class="List__title" v-else-if="institute && !searchActivated">لا توجد رهون خاصة بمنشأتك</h4>
                        <h4 class="List__title" v-else> لا توجد رهون خاصة بك</h4>

                    </div>
                </div>
            </div>

        </div>     
        <!-- <div v-if="records.length < 1 && selectedTab !== 0">
            <div class="row">
                <div class="col-md-12">
                    <div class="List__empty">
                        <img :src='require("./../../../public/img/folder.svg")' alt="No Data">
                        <h4 class="List__title" > لا توجد طلبات خاصة بك</h4>
                    </div>
                </div>
            </div>

        </div> -->
        <div class="text-xs-center" v-if="pager.totalPages > 1">

            <v-pagination v-model="pager.currentPage"
                          @input="changePage"
                          :length="pager.totalPages"
                          :total-visible="10"></v-pagination>
        </div>

    </div>
</div>